/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from '@/application';
import { getAgent } from './agent';

import loadingConfig from './config/loading.config.json';
import { IGetHolderGroupProps } from './components';
import { ICreateDistillerMethodsProps } from './components';

const is = require('is_js');

const SERVICE_NAME = 'DistillersDetailPageService';

export class DistillersDetailPageService {
  private static instance: DistillersDetailPageService;
  private vapp: VApplication;
  private criteria: any;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): DistillersDetailPageService {
    if (!DistillersDetailPageService.instance) {
      DistillersDetailPageService.instance = new DistillersDetailPageService(
        props
      );
    }
    return DistillersDetailPageService.instance;
  }

  private setCriteria(data: any) {
    this.criteria = [...this.criteria, ...data];
  }

  public resetCriteria() {
    this.criteria = [];
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async getPageContent(args: IGetHolderGroupProps) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    if (args?.where) {
      this.setCriteria(args?.where);
    }

    //Header Props
    compProps = await agent.getHeaderProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    //Settings Props
    compProps = await agent.getSettingsProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    //UserLists Props
    compProps = await agent.getAppCardListProps({
      ...args,
      where: [...this.criteria, ...args?.where],
    });
    if (compProps) {
      console.log(`inside service`, compProps);
      content = { ...content, ...compProps };
    }
    return content;
  }

  public getLoading() {
    return { ...(loadingConfig || {}) };
  }

  public async createDistiller(args: ICreateDistillerMethodsProps) {
    const agent = getAgent();
    return agent.createDistiller(args);
  }
}
